import { render, staticRenderFns } from "./costExpenses.vue?vue&type=template&id=8b20edae&scoped=true"
import script from "./costExpenses.vue?vue&type=script&lang=js"
export * from "./costExpenses.vue?vue&type=script&lang=js"
import style0 from "./costExpenses.vue?vue&type=style&index=0&id=8b20edae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b20edae",
  null
  
)

export default component.exports